module.exports = __webpack_public_path__ + "static/img/rank2.0fca0910.svg";